import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { userlogout, acquireLogoutLock } from '../../Shared/Slice/AuthSlice';
import showToast from '../../Shared/Utils/ToastNotification';
import { Menu, X, User, Heart, FileText, LogOut } from 'react-feather';
import { jwtDecode } from 'jwt-decode';
import { restoreAdminAndNavigate } from '../../Shared/Utils/impersonation';
import logo from '../../assets/imgs/swimscore-logo.png';
import partnerVideo from '../../assets/videos/kling_20251202_Image_to_Video_Slow_stead_6083_0.mp4';

import './Nav.scss';

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn, user } = useSelector((state) => state.auth);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const getDisplayName = () => {
    if (!user) return 'User';

    const firstName = user.first_name || '';
    const lastName = user.last_name || '';

    if (firstName && lastName) {
      return `${firstName} ${lastName}`.trim();
    } else if (firstName) {
      return firstName;
    } else if (lastName) {
      return lastName;
    } else if (user.email) {
      return user.email.split('@')[0];
    }

    return 'User';
  };

  const displayName = getDisplayName();

  // 🔥 Get role from token
  let role = null;
  const token = sessionStorage.getItem('auth_token');

  if (token) {
    try {
      const decoded = jwtDecode(token);
      role = decoded.role; // "user" or "admin"
    } catch (err) {
      console.error('Invalid token:', err);
    }
  }

  const isAdmin = role === 'admin';

  const stopAndGoToPatients = async () => {
    await restoreAdminAndNavigate('/admin/patient-list', dispatch, navigate);
  };

  // 🔥 Menu items for normal USER
  const userMenuItems = [
    { label: 'Dashboard', icon: <FileText size={18} />, path: '/dashboard' },
    { label: 'Test History', icon: <FileText size={18} />, path: '/test-history' },
    { label: 'Account Info', icon: <User size={18} />, path: '/account-info' },
    { label: 'Order History', icon: <FileText size={18} />, path: '/orders' },
    { label: 'Add Partner', icon: <Heart size={18} />, path: '/add-spouse' },
    { label: 'Medication', icon: <FileText size={18} />, path: '/medication-status' },
    // { label: 'Schedule Consultation', icon: <Activity size={18} />, path: '/schedule-consultation' },
    // { label: 'Support / FAQ', icon: <Phone size={18} />, path: '/support' },
  ];

  // 🔥 Menu items for ADMIN
  const adminMenuItems = [
    { label: 'Account Info', icon: <User size={18} />, path: '/user-profile' },
    { label: 'Manage Offering', icon: <FileText size={18} />, path: '/admin/manage-offering' },
  ];
  console.log(role, 'role');
  const menuItems = role == 'admin' ? adminMenuItems : userMenuItems;

  const handleLogout = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const dropdownMenu = document.querySelector('.profile-dropdown .dropdown-menu');
    const dropdownToggle = document.querySelector('.profile-dropdown .dropdown-toggle');
    if (dropdownMenu && dropdownToggle) {
      dropdownMenu.classList.remove('show');
      dropdownToggle.classList.remove('show');
      dropdownToggle.setAttribute('aria-expanded', 'false');
    }

    if (sessionStorage.getItem('impersonating') === 'true') {
      stopAndGoToPatients();
      setIsMenuOpen(false);
      return;
    }

    if (!acquireLogoutLock()) return;
    dispatch(userlogout());
    showToast('info', 'Logged Out Successfully');
    setIsMenuOpen(false);
    navigate('/login');
  };

  const navigateAndClose = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  const handleDropdownNavigation = (path, e) => {
    e.preventDefault();
    navigate(path);
    const dropdownMenu = document.querySelector('.profile-dropdown .dropdown-menu');
    const dropdownToggle = document.querySelector('.profile-dropdown .dropdown-toggle');
    if (dropdownMenu && dropdownToggle) {
      dropdownMenu.classList.remove('show');
      dropdownToggle.classList.remove('show');
      dropdownToggle.setAttribute('aria-expanded', 'false');
    }
  };

  return (
    <nav className="navbar modern-navbar">
      <div className=" container">
        <div className="navbar-left">
          <img src={logo} alt="logo" />
        </div>

        <div className="navbar-items d-none d-md-flex">
          <ul className="navbar-nav d-flex flex-row">
            <li className="nav-item">
              <a
                className={`nav-link d-flex align-items-center gap-2 ${location.pathname === (isAdmin ? '/admin/dashboard' : '/dashboard') ? 'active' : ''}`}
                aria-current={location.pathname === (isAdmin ? '/admin/dashboard' : '/dashboard') ? 'page' : undefined}
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigate(isAdmin ? '/admin/dashboard' : '/dashboard');
                }}
              >
                <svg width="27" height="18" viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect
                    x="0.9"
                    y="0.9"
                    width="9.9"
                    height="5.4"
                    rx="0.9"
                    stroke={location.pathname === '/dashboard' ? '#1B72EC' : '#EEF3FC'}
                    strokeWidth="1.8"
                  />
                  <rect
                    x="0.9"
                    y="11.7"
                    width="9.9"
                    height="5.4"
                    rx="0.9"
                    stroke={location.pathname === (isAdmin ? '/admin/dashboard' : '/dashboard') ? '#1B72EC' : '#EEF3FC'}
                    strokeWidth="1.8"
                  />
                  <rect
                    x="16.2008"
                    y="0.9"
                    width="9.9"
                    height="16.2"
                    rx="0.9"
                    stroke={location.pathname === (isAdmin ? '/admin/dashboard' : '/dashboard') ? '#1B72EC' : '#EEF3FC'}
                    strokeWidth="1.8"
                  />
                </svg>
                DASHBOARD
              </a>
            </li>

            {/* Middle tabs: role-based */}
            {!isAdmin ? (
              <>
                {/* USER: Test History */}
                <li className="nav-item">
                  <a
                    className={`nav-link d-flex align-items-center gap-1 ${location.pathname === '/test-history' ? 'active' : ''}`}
                    aria-current={location.pathname === '/test-history' ? 'page' : undefined}
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/test-history');
                    }}
                  >
                    <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.04505 7.04504C10.9359 3.15417 17.2443 3.15417 21.1351 7.04504C25.026 10.9359 25.026 17.2443 21.1351 21.1351C17.2443 25.026 10.9359 25.026 7.04505 21.1351C5.19541 19.2855 4.22505 16.8896 4.13397 14.4667"
                        stroke={location.pathname === '/test-history' ? '#1B72EC' : '#EEF3FC'}
                        strokeWidth="1.5"
                        strokeLinecap="square"
                      />
                      <path
                        d="M13.7578 8.1123V15.4187H19.0715"
                        stroke={location.pathname === '/test-history' ? '#1B72EC' : '#EEF3FC'}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M6.11914 4.79102V8.11208H9.44021"
                        stroke={location.pathname === '/test-history' ? '#1B72EC' : '#EEF3FC'}
                        strokeWidth="1.5"
                      />
                    </svg>
                    TEST HISTORY
                  </a>
                </li>
              </>
            ) : (
              <>
                {/* ADMIN: Patients */}
                <li className="nav-item">
                  <a
                    className={`nav-link d-flex align-items-center gap-1 ${location.pathname === '/admin/patient-list' ? 'active' : ''}`}
                    aria-current={location.pathname === '/admin/patient-list' ? 'page' : undefined}
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/admin/patient-list');
                    }}
                  >
                    <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.04505 7.04504C10.9359 3.15417 17.2443 3.15417 21.1351 7.04504C25.026 10.9359 25.026 17.2443 21.1351 21.1351C17.2443 25.026 10.9359 25.026 7.04505 21.1351C5.19541 19.2855 4.22505 16.8896 4.13397 14.4667"
                        stroke={location.pathname === '/admin/patient-list' ? '#1B72EC' : '#EEF3FC'}
                        strokeWidth="1.5"
                        strokeLinecap="square"
                      />
                      <path
                        d="M13.7578 8.1123V15.4187H19.0715"
                        stroke={location.pathname === '/admin/patient-list' ? '#1B72EC' : '#EEF3FC'}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M6.11914 4.79102V8.11208H9.44021"
                        stroke={location.pathname === '/admin/patient-list' ? '#1B72EC' : '#EEF3FC'}
                        strokeWidth="1.5"
                      />
                    </svg>
                    PATIENTS
                  </a>
                </li>

                {/* ADMIN: Review Queue */}
                <li className="nav-item">
                  <a
                    className={`nav-link d-flex align-items-center gap-2 ${location.pathname.startsWith('/admin/review-queue') ? 'active' : ''}`}
                    aria-current={location.pathname.startsWith('/admin/review-queue') ? 'page' : undefined}
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/admin/review-queue');
                    }}
                  >
                    <FileText size={18} stroke={location.pathname.startsWith('/admin/review-queue') ? '#1B72EC' : '#EEF3FC'} />
                    REVIEW QUEUE
                  </a>
                </li>

                {/* ADMIN: Prompt Management */}
                <li className="nav-item">
                  <a
                    className={`nav-link d-flex align-items-center gap-2 ${location.pathname.startsWith('/admin/prompt-management') ? 'active' : ''}`}
                    aria-current={location.pathname.startsWith('/admin/prompt-management') ? 'page' : undefined}
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/admin/prompt-management');
                    }}
                  >
                    <FileText size={18} stroke={location.pathname.startsWith('/admin/prompt-management') ? '#1B72EC' : '#EEF3FC'} />
                    PROMPT MANAGEMENT
                  </a>
                </li>

                {/* ADMIN: Results */}
                <li className="nav-item">
                  <a
                    className={`nav-link d-flex align-items-center gap-2 ${location.pathname === '/admin/report' ? 'active' : ''}`}
                    aria-current={location.pathname === '/admin/report' ? 'page' : undefined}
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/admin/report');
                    }}
                  >
                    <svg width="15" height="23" viewBox="0 0 15 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <mask
                        id="path-1-outside-1_362_657_admin"
                        maskUnits="userSpaceOnUse"
                        x="-0.498047"
                        y="-0.497314"
                        width="16"
                        height="24"
                        fill="black"
                      >
                        <rect fill="white" x="-0.498047" y="-0.497314" width="16" height="24" />
                        <path d="M7.91797 1.78882C8.23507 1.27407 9.02888 1.49874 9.0293 2.10327V9.98413H12.8496C13.3187 9.98444 13.6061 10.4986 13.3604 10.8982L7.03418 21.1785C6.71711 21.6937 5.92286 21.469 5.92285 20.864V12.9841H2.10254C1.6334 12.9838 1.34587 12.4687 1.5918 12.0691L7.91797 1.78882Z" />
                      </mask>
                      <path
                        d="M7.91797 1.78882L6.64085 1.00207L6.64047 1.00269L7.91797 1.78882ZM9.0293 2.10327H10.5293V2.10223L9.0293 2.10327ZM9.0293 9.98413H7.5293V11.4841H9.0293V9.98413ZM12.8496 9.98413L12.8506 8.48413H12.8496V9.98413ZM13.3604 10.8982L14.6378 11.6843L14.638 11.684L13.3604 10.8982ZM7.03418 21.1785L8.31167 21.9646L8.31168 21.9646L7.03418 21.1785ZM5.92285 20.864H4.42285V20.864L5.92285 20.864ZM5.92285 12.9841H7.42285V11.4841H5.92285V12.9841ZM2.10254 12.9841L2.10156 14.4841H2.10254V12.9841ZM1.5918 12.0691L2.86929 12.8552L2.86929 12.8552L1.5918 12.0691ZM7.91797 1.78882L9.19509 2.57557C8.71914 3.34816 7.52992 3.01091 7.5293 2.10431L9.0293 2.10327L10.5293 2.10223C10.5278 -0.0134221 7.75101 -0.800028 6.64085 1.00207L7.91797 1.78882ZM9.0293 2.10327H7.5293V9.98413H9.0293H10.5293V2.10327H9.0293ZM9.0293 9.98413V11.4841H12.8496V9.98413V8.48413H9.0293V9.98413ZM12.8496 9.98413L12.8486 11.4841C12.1459 11.4837 11.7134 10.7127 12.0827 10.1124L13.3604 10.8982L14.638 11.684C15.4988 10.2844 14.4915 8.4852 12.8506 8.48413L12.8496 9.98413ZM13.3604 10.8982L12.0829 10.1121L5.75668 20.3923L7.03418 21.1785L8.31168 21.9646L14.6378 11.6843L13.3604 10.8982ZM7.03418 21.1785L5.75669 20.3923C6.23198 19.62 7.42283 19.9559 7.42285 20.864L5.92285 20.864L4.42285 20.864C4.42289 22.9821 7.20224 23.7675 8.31167 21.9646L7.03418 21.1785ZM5.92285 20.864H7.42285V12.9841H5.92285H4.42285V20.864H5.92285ZM5.92285 12.9841V11.4841H2.10254V12.9841V14.4841H5.92285V12.9841ZM2.10254 12.9841L2.10352 11.4841C2.808 11.4846 3.23783 12.2563 2.86929 12.8552L1.5918 12.0691L0.314303 11.283C-0.546096 12.6811 0.458793 14.4831 2.10156 14.4841L2.10254 12.9841ZM1.5918 12.0691L2.86929 12.8552L9.19546 2.57495L7.91797 1.78882L6.64047 1.00269L0.314301 11.283L1.5918 12.0691Z"
                        fill={location.pathname === '/admin/report' ? '#1B72EC' : '#EEF3FC'}
                        mask="url(#path-1-outside-1_362_657_admin)"
                      />
                    </svg>
                    RESULTS
                  </a>
                </li>
              </>
            )}
          </ul>
        </div>

        {isLoggedIn && (
          <div className="navbar-right d-none d-md-flex">
            {/* {isImpersonating && (
              <button className="refer-btn" onClick={stopAndGoToPatients}>
                Login as Admin
              </button>
            )} */}
            {/* Report Type Dropdown - REMOVED */}

            {/* Earn $100 - USER ONLY 
            {!isAdmin && (
              <div className="earn">
                <a href="#">Earn $100</a>
              </div>
            )}*/}

            <div className="dropdown profile-dropdown">
              <a
                className="btn profile-btn align-items-center d-flex gap-2 dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.00011 7.79454C8.13088 7.79454 9.21448 7.38455 10.0146 6.653C10.8139 5.92224 11.2632 4.9307 11.2632 3.89766C11.2632 2.86382 10.8139 1.87232 10.0146 1.14154C9.21452 0.41078 8.13086 0 7.00011 0C5.86936 0 4.78574 0.41076 3.98558 1.14154C3.18631 1.8723 2.73702 2.86384 2.73702 3.89766C2.73702 4.93074 3.18629 5.92222 3.98558 6.653C4.7857 7.38453 5.86936 7.79454 7.00011 7.79454ZM7.00011 1.23073C8.17968 1.23073 9.24312 1.88073 9.695 2.87688C10.146 3.87303 9.89692 5.02077 9.06231 5.78306C8.22853 6.54536 6.97409 6.77381 5.88366 6.36075C4.79412 5.94843 4.08318 4.97615 4.08318 3.89764C4.08822 2.42687 5.39144 1.23525 7.00011 1.23073ZM7.61934 8.20532H6.38088C4.68892 8.20686 3.06762 8.82224 1.87115 9.91608C0.675597 11.0099 0.00252 12.4922 0 14.0392C0.000841292 14.6539 0.460212 15.1885 1.11311 15.3354C3.03811 15.7777 5.01523 16.0008 7 16C8.98473 16.0008 10.962 15.7777 12.8869 15.3354C13.5398 15.1885 13.9992 14.6539 14 14.0392C13.9975 12.4923 13.3244 11.01 12.1288 9.91608C10.9324 8.82224 9.3114 8.20686 7.61934 8.20532ZM12.5639 14.1453C8.90992 14.9745 5.09029 14.9745 1.43629 14.1453C1.38413 14.1315 1.34795 14.0884 1.34627 14.0391C1.34879 12.8184 1.87969 11.6491 2.82368 10.786C3.76682 9.92369 5.04645 9.43753 6.38097 9.43599H7.61943C8.9538 9.43753 10.2336 9.92369 11.1767 10.786C12.1207 11.6491 12.6516 12.8182 12.6541 14.0391C12.6525 14.0884 12.6161 14.1315 12.5639 14.1453Z"
                    fill="#EEF3FC"
                  />
                </svg>
                {displayName.toUpperCase()}
                <span className="custom-arrow">
                  <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L7 7L13 1" stroke="#EEF3FC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              </a>

              <ul className="dropdown-menu custom-dropdown">
                {/* Primary CTA - USER ONLY */}
                {!isAdmin && (
                  <li className="dropdown-cta">
                    <button className="btn btn-primary">Order new test</button>
                  </li>
                )}

                <li>
                  <hr className="dropdown-divider" />
                </li>

                {/* Menu links - ROLE BASED */}
                {!isAdmin ? (
                  <>
                    {/* USER MENU ITEMS */}
                    <li className="pt-4 px-3">
                      <a className="dropdown-item px-0" href="#" onClick={(e) => handleDropdownNavigation('/account-info', e)}>
                        Account info
                      </a>
                    </li>
                    <li className="px-3">
                      <a className="dropdown-item px-0" href="#" onClick={(e) => handleDropdownNavigation('/orders', e)}>
                        Order history
                      </a>
                    </li>
                    <li className="px-3">
                      <a className="dropdown-item px-0" data-bs-toggle="modal" data-bs-target="#addPartnerModal">
                        Add partner
                      </a>
                    </li>
                    <li className="px-3">
                      <a className="dropdown-item px-0" href="#" onClick={(e) => handleDropdownNavigation('/medication-status', e)}>
                        Medication
                      </a>
                    </li>
                    {/* <li className="px-3">
                      <a className="dropdown-item px-0 mb-3" href="#" onClick={(e) => handleDropdownNavigation('/support', e)}>
                        Support / FAQ
                      </a>
                    </li> */}
                  </>
                ) : (
                  <>
                    {/* ADMIN MENU ITEMS */}
                    <li className="pt-4 px-3">
                      <a className="dropdown-item px-0" href="#" onClick={(e) => handleDropdownNavigation('/user-profile', e)}>
                        Account Info
                      </a>
                    </li>
                    <li className="px-3">
                      <a className="dropdown-item px-0 mb-3" href="#" onClick={(e) => handleDropdownNavigation('/admin/manage-offering', e)}>
                        Manage Offering Prices
                      </a>
                    </li>
                  </>
                )}

                {/* Coming soon section */}
                <li className="dropdown-item disabled-item px-3">
                  Schedule Consultation <span className="badge-soon">COMING SOON</span>
                </li>
                <li className="dropdown-item disabled-item px-3">
                  Freeze your semen <span className="badge-soon">COMING SOON</span>
                </li>
                <li className="dropdown-item disabled-item px-3">
                  Test your blood <span className="badge-soon">COMING SOON</span>
                </li>

                {/* Logout */}
                <li className="logout-wrapper px-3 pb-3">
                  <button className="btn btn-secondary d-flex justify-content-center gap-2 align-items-center" onClick={handleLogout}>
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8 10.1C7.50294 10.1 7.1 10.5029 7.1 11C7.1 11.4971 7.50294 11.9 8 11.9H19C19.4971 11.9 19.9 11.4971 19.9 11C19.9 10.5029 19.4971 10.1 19 10.1H8Z"
                        fill="#EEF3FC"
                      />
                      <path d="M13 5L19 11L13 17" stroke="#EEF3FC" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M9 3H3V19H9" stroke="#EEF3FC" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    Log out
                  </button>
                </li>
              </ul>
            </div>
            {/* add partner modal here - USER ONLY */}
            {!isAdmin && (
              <div className="modal fade addPartnermodal" id="addPartnerModal" tabIndex="1" aria-labelledby="addPartnerModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                  <div className="modal-content">
                    <div className="modal-header" style={{ position: 'relative', overflow: 'hidden', background: 'none' }}>
                      <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          zIndex: 0,
                        }}
                      >
                        <source src={partnerVideo} type="video/mp4" />
                      </video>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        style={{ position: 'relative', zIndex: 1 }}
                      ></button>
                      <div className="graph" style={{ position: 'relative', zIndex: 1 }}></div>
                    </div>
                    <div className="modal-body">
                      <div className="">
                        <h3 className="modal-title" id="addPartnerModalLabel">
                          Add your partner
                        </h3>
                      </div>
                      <p>
                        Sharing your dashboard helps you stay on the same page. When you add your partner, they can view your semen test results,
                        track changes over time and follow your next steps with you.
                      </p>
                      <p>You stay in control. You can remove access at any moment.</p>
                      <div className="row">
                        <div className="col-md-6">
                          <form>
                            <div className="form-group">
                              <label>Partners e-mail</label>
                              <input className="form-control" type="email" name="email" placeholder="Enter email" />
                            </div>
                          </form>
                        </div>
                        <div className="col-md-6 d-flex align-items-end">
                          <button className="btn btn-primary w-fit px-4">send</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Toggle Button */}
        <button className="menu-btn mobile-menu" onClick={() => setIsMenuOpen((prev) => !prev)}>
          {isMenuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
        {/* Sidebar Drawer */}
        <div className={`nav-sheet ${isMenuOpen ? 'open' : ''}`}>
          <div className="nav-sheet-header">
            <div className="header-row">
              <img src={logo} alt="logo" />
              <button className="close-menu-btn" onClick={() => setIsMenuOpen(false)}>
                <X size={32} />
              </button>
            </div>
          </div>

          <div className="nav-sheet-body">
            {/* 🔥 ROLE-BASED MENU */}
            {menuItems.map((item, index) => (
              <button key={index} className="nav-item" onClick={() => navigateAndClose(item.path)}>
                {item.label}
              </button>
            ))}

            {/* Coming soon section */}
            <ul className="custom-dropdown p-0 w-auto mb-1">
              <li className="dropdown-item disabled-item">
                Schedule Consultation <span className="badge-soon">COMING SOON</span>
              </li>
              <li className="dropdown-item disabled-item">
                Freeze your semen <span className="badge-soon">COMING SOON</span>
              </li>
              <li className="dropdown-item disabled-item">
                Test your blood <span className="badge-soon">COMING SOON</span>
              </li>

              {/* Primary CTA - USER ONLY */}
              {!isAdmin && (
                <li className="dropdown-cta mb-0 mt-5">
                  <button className="btn btn-primary">Order new test</button>
                </li>
              )}
            </ul>

            {/* Logout ALWAYS visible */}
            <button className="btn btn-text d-flex gap-2 justify-content-center align-items-center text-decoration-underline" onClick={handleLogout}>
              <LogOut size={18} /> Logout
            </button>
          </div>
        </div>

        {/* Background overlay */}
        {isMenuOpen && <div className="nav-overlay" onClick={() => setIsMenuOpen(false)}></div>}
      </div>
    </nav>
  );
};

export default Navbar;
